import { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import SkeletonLoader from './SkeletonLoader';

/**
 * Lazy loading wrapper for sections that should only load when visible
 */
const LazySection = ({
    children,
    fallback = <SkeletonLoader className="h-96" />,
    threshold = 0.1,
    rootMargin = '100px',
    className = ''
}) => {
    const { elementRef, hasIntersected } = useIntersectionObserver({
        threshold,
        rootMargin
    });

    return (
        <div ref={elementRef} className={className}>
            {hasIntersected ? (
                <Suspense fallback={fallback}>
                    {children}
                </Suspense>
            ) : (
                fallback
            )}
        </div>
    );
};

LazySection.propTypes = {
    children: PropTypes.node.isRequired,
    fallback: PropTypes.node,
    threshold: PropTypes.number,
    rootMargin: PropTypes.string,
    className: PropTypes.string
};

export default LazySection;